import { BaseAuthenticatedComponent } from './../base-authenticated/base-authenticated.component';
import { Component, OnInit, Inject, Output, Input, OnDestroy } from '@angular/core';

import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';


import {
    HMServerDataSource,
    filterNumber,
    filterLikeLang,
    prepareLang,
    filterLang,
    filterLike,
    filterText,
    preparePregDate,
    filterBoolean,
} from '@hm_app/@core/data/happymamma.datasource';
import { Router } from '@angular/router';
import { HmModelRest, HmRestType } from '@hm_app/@core/models/abstract_model';
import { ViewCell } from 'ng2-smart-table';
import { EventEmitter } from 'events';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertModalComponent } from '@hm_app/shared/alert-modal/alert-modal.component';
import * as _ from 'lodash-es';
import { NbToastrService } from '@nebular/theme';

import { ɵbo as Ng2SmartTableComponent } from 'ng2-smart-table';
import { NbRoleProvider } from '@nebular/security';
import { AuthUser } from '@hm_app/@core/models/auth_user';

export function settingsButtonsAdd() {
    return {
        addButtonContent: '<i class="nb-plus"></i>',
        createButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
    };
}

export function settingsDefault() {
    return {
        actions: {
            columnTitle: '',
            position: 'right',
        },
        add: settingsButtonsAdd(),
        edit: settingsButtonsEdit(),
        delete: settingsButtonsDelete(),
    };
}


export function settingsEditOnly() {
    return {
        actions: {
            columnTitle: '',
            position: 'right',
        },
        edit: settingsButtonsEdit(),
        add: null,
        delete: null,
    };
}


export function settingsReadOnly() {
    return {
        actions: false,
    };
}



// export function settingsDefaultWithRigeneraToken() {
//   return {

//     add: settingsButtonsAdd(),
//     edit: settingsButtonsEdit(),
//     delete: settingsButtonsDelete(),
//     actions: {
//       columnTitle: "Actions",
//       position: "right",
//       custom: [ { name: 'view', title: '<i class="ion-refresh"></i> ', },]
//     },
//   };
// }

export function settingsButtonsEdit() {
    return {
        editButtonContent: '<i class="nb-edit"></i>',
        saveButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
        confirmSave: true,
    };
}


export function settingsButtonsDelete() {
    return {
        deleteButtonContent: '<i class="nb-trash"></i>',
        confirmDelete: true,
    };
}

export function settingsID() {
    return {
        title: 'ID',
        type: 'text',
        sort: true,
        filterFunction: filterNumber,
        editable: false,
        addable: false,
        width: '5%',
        valuePrepareFunction: filterNumber,
    };
}

export function settingsFieldMultiLang(
    title: string,
    use_like: boolean = true,
    sort: boolean = true,
    width: string = null,
) {
    return {
        title: title,
        filterFunction: use_like ? filterLikeLang : filterLang,
        type: 'text',
        sort: sort,
        valuePrepareFunction: prepareLang,
        width: width,
    };
}

export function settingsFieldMultiLangRichText(
    title: string,
    use_like: boolean = true,
    sort: boolean = true,
    width: string = null,
) {
    return {
        title: title,
        filterFunction: use_like ? filterLikeLang : filterLang,
        type: 'html',
        sort: sort,
        valuePrepareFunction: prepareLang,
        width: width,
    };
}

export function settingsFieldRichText(
    title: string,
    use_like: boolean = true,
    sort: boolean = true,
    width: string = null,
) {
    return {
        title: title,
        filterFunction: use_like ? filterLikeLang : filterText,
        type: 'html',
        sort: sort,
        width: width,
    };
}

export function settingsFieldText(
    title: string,
    use_like: boolean = true,
    sort: boolean = true,
    width: string = null,
) {
    return {
        title: title,
        filterFunction: use_like ? filterLike : filterText,
        type: 'text',
        sort: sort,
        width: width,
    };
}

export function settingsFieldPregnancyDate(
    title: string,
    sort: boolean = true,
    width: string = null,
) {
    return {
        title: title,
        type: 'html',
        sort: sort,
        valuePrepareFunction: preparePregDate,
        width: width,
    };
}


export function settingsFieldNumber(
    title: string,
    enable_filter: boolean = true,
    sort: boolean = true,
    width: string = null,
) {
    return {
        title: title,
        filterFunction: enable_filter ? filterNumber : null,
        type: 'number',
        sort: sort,
        valuePrepareFunction: filterNumber,
        width: width,
        editor: {
            type: 'text',
            valuePrepareFunction: filterNumber,
            filterFunction: enable_filter ? filterNumber : null,
        },
    };
}

export function settingsFieldBoolean(title: string, sort: boolean = true) {
    return {
        title: title,
        type: 'boolean',
        sort: sort,
        valuePrepareFunction: filterBoolean,
        editor: {
            type: 'checkbox',
            template: '<nb-checkbox (change)=\'onToggle($event)\'></nb-checkbox>',
            config: {
                resetText: 'Reset',
            },
        },
        filter: {
            type: 'checkbox',
            config: {
                resetText: 'Reset',

            },
        },
    };
}

export function settingsFieldCompleter(
    titolo,
    dictionary: Map<number, HmModelRest>,
    searchFields = 'id,nome.it',
    titleField = 'nome.it',
    descriptionField = null,
): {} {
    return {
        valuePrepareFunction: (cel: string) => {
            const k = parseInt(cel, 10);
            if (!dictionary || !dictionary.get(k)) return cel;
            return dictionary.get(k).getLabel();
        },

        title: titolo,
        type: 'text',
        sort: true,
        filter: {
            type: 'completer',
            config: {
                selectText: 'Seleziona...',
                completer: {
                    data: Array.from(dictionary.values()),
                    searchFields: searchFields,
                    titleField: titleField,
                    descriptionField: descriptionField,
                },
            },
        },
        editor: {
            type: 'completer',
            config: {
                selectText: 'Seleziona...',
                completer: {
                    data: Array.from(dictionary.values()),
                    searchFields: searchFields,
                    titleField: titleField,
                    descriptionField: descriptionField,
                },
            },
        },
    };
}

export function settingsFieldSelect(
    titolo,
    dictionary: Map<number, HmModelRest>,
    sort: boolean = true,
    filter: boolean = true,
): {} {
    const resp = {
        valuePrepareFunction: (cel: string) => {
            const k = parseInt(cel, 10);
            if (!dictionary || !dictionary.get(k)) return cel;
            return dictionary.get(k).getLabel();
        },

        title: titolo,
        type: 'text',
        sort: sort,
        editor: {
            type: 'list',
            config: {
                selectText: 'Seleziona...',
                list: Array.from(dictionary.values()),
            },
        },
    };
    if (filter)
        resp['filter'] = {
            type: 'list',
            config: {
                selectText: 'Seleziona...',
                list: Array.from(dictionary.values()),
            },
        };
    return resp;
}

@Component({
    selector: 'button-view',
    template: `
    <button (click)="onClick()">{{ renderValue }}</button>
  `,
})
export class ButtonViewComponent implements ViewCell, OnInit {
    renderValue: string;
    protected id: number;

    @Input() value: string | number;
    @Input() rowData: any;

    @Output() save: EventEmitter = new EventEmitter();

    ngOnInit() {
        if (this.value == null) return;
        this.renderValue = this.value.toString().toUpperCase();
    }

    onClick() {
        this.save.emit(this.rowData);

        alert(`${this.rowData} clicked!`);
    }
}

// class Ng2SmartTableComponent100 extends Ng2SmartTableComponent {
//     constructor() {
//         super();
//         //this.defaultSettings.pager.perPage = 100;
//     }
// }

// // modifico i parametri di default
// Ng2SmartTableComponent.prototype.prepareSettings = function () {
//     const x = _.merge(
//         {},
//         this.defaultSettings,
//         {
//             pager: {
//                 display: true,
//                 perPage: 100,
//             },
//         },
//         this.settings,
//     );
//     return x;
// };

@Component({
    selector: 'app-strutture',
    templateUrl: 'generic-table.component.html',
    styleUrls: ['generic-table.component.css'],
})
export class GenericTableComponent<T extends HmModelRest> extends BaseAuthenticatedComponent implements OnInit, OnDestroy {
    settings: {} = false;

    user: AuthUser = null;
    protected id: number;
    protected alive: boolean = true;

    getSettings() {
        return {};
    }

    get titolo(): string {
        return '-';
    }
    source: HMServerDataSource<T>;

    constructor(
        @Inject(HmModelRest) classType: HmRestType<T>,
        protected hmService: HappyMammaService,
        protected router: Router,
        protected modalService: NgbModal,
        protected toastrService: NbToastrService,
        protected roleProvider: NbRoleProvider,
    ) {
        super(hmService, toastrService, roleProvider);
        this.source = new HMServerDataSource<T>(hmService, classType);
        this.id = null;

        this.hmService.auth_user$.subscribe(utente => {
            this.user = utente;
            // console.log(utente);
        });
        this.user = this.hmService._auth_user;

    }

    async fetchDependenties() {
        await this.hmService.fetchUser();
     }

    async ngOnInit() {
        await this.fetchDependenties();
        this.settings = this.getSettings();
    }

    async ngOnDestroy() {
        // Called once, before the instance is destroyed.
        // Add 'implements OnDestroy' to the class.
        this.alive = false;
    }

    onDeleteConfirm(event): void {
        this.openConfirmDeletePopup(
            'Eliminazione',
            'Confermi l\'eliminazione?',
            'Conferma',
            'Annulla',
            event.data,
            false,
        );
    }


    onDelete(event): void {
        this.openConfirmDeletePopup(
            'Eliminazione',
            'Confermi l\'eliminazione?',
            'Conferma',
            'Annulla',
            event.data,
            false,
        );
    }

    onEdit(event: any): void {
        // pass
    }

    onUserRowSelect(event: any): void {
        // pass
    }

    onEditConfirm(event: any): void {
        this.openConfirmEditPopup(
            'Modifica elemento',
            'Confermi la modifica?',
            'Conferma',
            'Annulla',
            event,
            false,
        );
    }

    onCreate(event: any): void {
        // pass
    }

    onCreateConfirm(event: any): void {
        // pass
    }

    openConfirmPopup(
        modalHeader: string,
        modalContent: string,
        modalOkButton: string,
        modalCancelButton: string,
        modalCancelEnabled: boolean = true,
    ) {
        const activeModal = this.modalService.open(AlertModalComponent, {
            size: 'sm',
            container: 'nb-layout',
            backdrop: true,
        });
        activeModal.componentInstance.modalHeader = modalHeader;
        activeModal.componentInstance.modalContent = modalContent;

        activeModal.componentInstance.modalOkText = modalOkButton;
        if (modalCancelEnabled) {
            activeModal.componentInstance.modalCancelText = modalCancelButton;
            activeModal.componentInstance.modalCancelEnabled = modalCancelEnabled;
        }
        activeModal.componentInstance.action.subscribe(okButtonPressed => {
            if (okButtonPressed) {
                this.onPopupConfirm();
                activeModal.componentInstance.action.unsubscribe();
            } else {
                this.id = null;
            }
        });
    }

    openConfirmEditPopup(
        modalHeader: string,
        modalContent: string,
        modalOkButton: string,
        modalCancelButton: string,
        event: any,
        modalCancelEnabled: boolean = true,
    ) {
        const activeModal = this.modalService.open(AlertModalComponent, {
            size: 'sm',
            container: 'nb-layout',
            backdrop: 'static',
        });
        activeModal.componentInstance.modalHeader = modalHeader;
        activeModal.componentInstance.modalContent = modalContent;

        activeModal.componentInstance.modalOkText = modalOkButton;
        if (modalCancelEnabled) {
            activeModal.componentInstance.modalCancelText = modalCancelButton;
            activeModal.componentInstance.modalCancelEnabled = modalCancelEnabled;
        }
        activeModal.componentInstance.action.subscribe(okButtonPressed => {
            if (okButtonPressed) {
                this.source.update(event.data, event.newData);
                activeModal.componentInstance.action.unsubscribe();
            }
        });
    }

    openConfirmDeletePopup(
        modalHeader: string,
        modalContent: string,
        modalOkButton: string,
        modalCancelButton: string,
        data: any,
        modalCancelEnabled: boolean = true,
    ) {
        const activeModal = this.modalService.open(AlertModalComponent, {
            size: 'sm',
            container: 'nb-layout',
            backdrop: 'static',
        });
        activeModal.componentInstance.modalHeader = modalHeader;
        activeModal.componentInstance.modalContent = modalContent;

        activeModal.componentInstance.modalOkText = modalOkButton;
        if (modalCancelEnabled) {
            activeModal.componentInstance.modalCancelText = modalCancelButton;
            activeModal.componentInstance.modalCancelEnabled = modalCancelEnabled;
        }
        activeModal.componentInstance.action.subscribe(okButtonPressed => {
            if (okButtonPressed) {
                this.source.remove(data);
                activeModal.componentInstance.action.unsubscribe();
            }
        });
    }
    onPopupConfirm() { }
}
